// components/admin/quotes/StatusBadge.jsx
import { Clock, Send, Check, X, AlertCircle } from 'lucide-react';

export default function StatusBadge({ status }) {
  const config = {
    pending: { 
      label: 'En attente', 
      icon: <Clock size={12} />,
      className: 'bg-yellow-100 text-yellow-800 border-yellow-200' 
    },
    sent: { 
      label: 'Envoyé', 
      icon: <Send size={12} />,
      className: 'bg-blue-100 text-blue-800 border-blue-200' 
    },
    accepted: { 
      label: 'Accepté', 
      icon: <Check size={12} />,
      className: 'bg-green-100 text-green-800 border-green-200' 
    },
    declined: { 
      label: 'Refusé', 
      icon: <X size={12} />,
      className: 'bg-red-100 text-red-800 border-red-200' 
    },
    expired: { 
      label: 'Expiré', 
      icon: <AlertCircle size={12} />,
      className: 'bg-gray-100 text-gray-800 border-gray-200' 
    }
  };
  
  const { label, icon, className } = config[status] || config.pending;
  
  return (
    <span className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium border ${className}`}>
      {icon}
      {label}
    </span>
  );
}